import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
  AGENT_PERMISSIONS,
  AGENT_BOT_PERMISSIONS,
  ASSIGNMENT_POLICY_PERMISSIONS,
  AUTOMATION_PERMISSIONS,
  CANNED_RESPONSE_PERMISSIONS,
  CUSTOM_ATTRIBUTE_PERMISSIONS,
  INBOX_PERMISSIONS,
  INTEGRATION_PERMISSIONS,
  LABEL_PERMISSIONS,
  MACRO_PERMISSIONS,
  SLA_PERMISSIONS,
  TEAM_PERMISSIONS,
  WEBHOOK_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import apiDocs from './apiDocs/apiDocs.routes';
import billing from './billing/billing.routes';
import canned from './canned/canned.routes';
import inbox from './inbox/inbox.routes';
import templates from './templates/templates.routes';
import integrations from './integrations/integrations.routes';
import data from './data/data.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import sla from './sla/sla.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
import security from './security/security.routes';
import conversationWorkflow from './conversationWorkflow/conversationWorkflow.routes';
import captain from './captain/captain.routes';
import agentPauses from './agentPauses/agentPauses.routes';
import connections from './connections/connections.routes';
import whatsappInteractiveTemplates from './whatsappInteractiveTemplates/whatsappInteractiveTemplates.routes';

const SETTINGS_PERMISSIONS = [
  AGENT_PERMISSIONS,
  AGENT_BOT_PERMISSIONS,
  ASSIGNMENT_POLICY_PERMISSIONS,
  AUTOMATION_PERMISSIONS,
  CANNED_RESPONSE_PERMISSIONS,
  CUSTOM_ATTRIBUTE_PERMISSIONS,
  INBOX_PERMISSIONS,
  INTEGRATION_PERMISSIONS,
  LABEL_PERMISSIONS,
  MACRO_PERMISSIONS,
  SLA_PERMISSIONS,
  TEAM_PERMISSIONS,
  WEBHOOK_PERMISSIONS,
];

const CUSTOM_ROLE_SETTINGS_REDIRECTS = [
  { permission: CANNED_RESPONSE_PERMISSIONS, routeName: 'canned_list' },
  { permission: AGENT_PERMISSIONS, routeName: 'agent_list' },
  { permission: TEAM_PERMISSIONS, routeName: 'settings_teams_list' },
  { permission: INBOX_PERMISSIONS, routeName: 'settings_inbox_list' },
  { permission: LABEL_PERMISSIONS, routeName: 'labels_list' },
  { permission: CUSTOM_ATTRIBUTE_PERMISSIONS, routeName: 'attributes_list' },
  { permission: AUTOMATION_PERMISSIONS, routeName: 'automation_list' },
  { permission: AGENT_BOT_PERMISSIONS, routeName: 'agent_bots' },
  { permission: INTEGRATION_PERMISSIONS, routeName: 'settings_applications' },
  {
    permission: WEBHOOK_PERMISSIONS,
    routeName: 'settings_integrations_webhook',
  },
  { permission: MACRO_PERMISSIONS, routeName: 'macros_wrapper' },
  {
    permission: ASSIGNMENT_POLICY_PERMISSIONS,
    routeName: 'assignment_policy_index',
  },
  { permission: SLA_PERMISSIONS, routeName: 'sla_list' },
];

const getCustomRoleSettingsRedirect = () => {
  const currentAccount = store.getters.getCurrentAccount || {};
  const currentPermissions = currentAccount.permissions || [];
  const redirect = CUSTOM_ROLE_SETTINGS_REDIRECTS.find(({ permission }) =>
    currentPermissions.includes(permission)
  );

  return redirect?.routeName || 'canned_list';
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [
          ...ROLES,
          ...CONVERSATION_PERMISSIONS,
          ...SETTINGS_PERMISSIONS,
        ],
      },
      redirect: to => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'general_settings_index', params: to.params };
        }

        return { name: getCustomRoleSettingsRedirect(), params: to.params };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...assignmentPolicy.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...apiDocs.routes,
    ...billing.routes,
    ...canned.routes,
    ...inbox.routes,
    ...templates.routes,
    ...integrations.routes,
    ...data.routes,
    ...labels.routes,
    ...macros.routes,
    ...reports.routes,
    ...sla.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...security.routes,
    ...conversationWorkflow.routes,
    ...captain.routes,
    ...agentPauses.routes,
    ...connections.routes,
    ...whatsappInteractiveTemplates.routes,
  ],
};
